<template>
    <div class="_config">
        <div class="card">
            <div class="content">
                创建最低评分
                <span>{{ config.allowe_min_score }}</span>
            </div>
            <div class="btn"><el-button type="primary" size="small" @click="openDialog('allowe_min_score')">编辑</el-button></div>
        </div>
        <div class="card">
            <div class="content">用户创建Prompt开关</div>
            <div class="btn">
                <el-button type="primary" size="small" @click="handCreateSwitch('open')">一键开启</el-button>
                <el-button type="primary" size="small" @click="handCreateSwitch('close')">一键关闭</el-button>
            </div>
        </div>
        <div class="card">
            <div class="content">
                免费优化次数
                <span>{{ config.free_optimize_count }}</span>
            </div>
            <div class="btn"><el-button type="primary" size="small" @click="openDialog('free_optimize_count')">编辑</el-button></div>
        </div>
        <div class="card">
            <div class="content">
                免费获取评分次数
                <span>{{ config.free_score_count }}</span>
            </div>
            <div class="btn"><el-button type="primary" size="small" @click="openDialog('free_score_count')">编辑</el-button></div>
        </div>
        <div class="card">
            <div class="content">
                免费生成图片次数
                <span>{{ config.free_imagine_count }}</span>
            </div>
            <div class="btn"><el-button type="primary" size="small" @click="openDialog('free_imagine_count')">编辑</el-button></div>
        </div>
        <div class="card">
            <div class="content">
                评分消耗积分
                <span>{{ config.score_points }}</span>
            </div>
            <div class="btn"><el-button type="primary" size="small" @click="openDialog('score_points')">编辑</el-button></div>
        </div>
        <div class="card">
            <div class="content">
                优化消耗积分
                <span>{{ config.optimize_points }}</span>
            </div>
            <div class="btn"><el-button type="primary" size="small" @click="openDialog('optimize_points')">编辑</el-button></div>
        </div>
        <div class="card">
            <div class="content">
                生成图片消耗积分
                <span>{{ config.imagine_points }}</span>
            </div>
            <div class="btn"><el-button type="primary" size="small" @click="openDialog('imagine_points')">编辑</el-button></div>
        </div>

        <div class="card">
            <div class="content">
                邀请返佣奖励
                <span>{{ config.commission_reward }}</span>
            </div>
            <div class="btn"><el-button type="primary" size="small" @click="openDialog('commission_reward')">编辑</el-button></div>
        </div>
        <div class="card">
            <div class="content">邀请返佣比例</div>
            <div style="margin-top: 20px">
                受邀人:&nbsp;&nbsp;
                <b>{{ config.commission_reward_rate.split('_')[0] }}</b>
            </div>
            <div>
                邀请人:&nbsp;&nbsp;
                <b>{{ config.commission_reward_rate.split('_')[1] }}</b>
            </div>
            <div class="btn"><el-button type="primary" size="small" @click="openDialog('commission_reward_rate')">编辑</el-button></div>
        </div>

        <update-dialog :dialogVisible="updateFlag" :type="update_type" @closeModal="closeModal" v-if="updateFlag" />
    </div>
</template>

<script>
import serverApi from '../../server/index';
import UpdateDialog from './module/UpdateDialog.vue';

export default {
    name: 'login',
    components: {
        UpdateDialog,
    },
    data() {
        return {
            config: {
                allowe_min_score: '--',
                free_optimize_count: '--',
                free_score_count: '--',
                free_imagine_count: '--',
                optimize_points: '--',
                score_points: '--',
                imagine_points: '--',
                commission_reward: '--',
                commission_reward_rate: '--',
            },

            updateFlag: false,
            update_type: '',
        };
    },
    mounted() {
        this.initData();
    },
    methods: {
        initData() {
            this.getConfig();
        },
        async getConfig() {
            try {
                const { data } = await serverApi.getConfig();
                if (data.code !== 0) throw new Error(data.error);
                this.config = data.data;
            } catch (e) {
                this.$message({
                    message: e.message,
                    type: 'error',
                });
            }
        },

        async handCreateSwitch(status) {
            try {
                const { data } = await serverApi.batch_create_status({ status });
                if (data.code !== 0) throw new Error(data.error);
                this.$message({
                    message: status === 'open' ? '所有用户创建权限已开启' : '所有用户创建权限已关闭',
                    type: 'success',
                    duration: 5000,
                });
            } catch (e) {
                this.$message({
                    message: e.message,
                    type: 'error',
                });
            }
        },

        openDialog(type) {
            this.update_type = type;
            this.updateFlag = true;
        },
        closeModal(isUpdate) {
            this.updateFlag = false;
            if (isUpdate) {
                this.initData();
            }
        },
    },
};
</script>

<style lang="scss" scoped>
._config {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    grid-template-rows: auto auto;
    grid-gap: 30px;
    @media screen and (max-width: 750px) {
        grid-template-columns: repeat(1, minmax(0, 1fr));
    }
    @media screen and (min-width: 1300px) {
        grid-template-columns: repeat(3, minmax(0, 1fr));
    }
    @media screen and (min-width: 2000px) {
        grid-template-columns: repeat(4, minmax(0, 1fr));
    }

    .card {
        padding: 18px 18px 20px;
        border-radius: 16px;
        border: 1px solid #eaeef5;
        background: #050509;
        min-height: 100px;
        cursor: pointer;
        overflow-y: hidden;
        color: #fff;
        .content {
            display: flex;
            justify-content: space-between;
            align-items: center;
            font-size: 22px;
            span {
                font-size: 30px;
            }
        }
        .btn {
            margin-top: 20px;
            width: 100%;
            display: flex;
            button {
                width: 100%;
                height: 40px;
                font-size: 16px;
                color: #fff;
                border-radius: 10px;
                margin-right: 40px;
                &:last-child {
                    margin-right: 0;
                }
            }
        }
    }
}
</style>
